/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownEventAttendeeStatus } from '../models/db_DropdownEventAttendeeStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EventAttendeeStatuses {
    /**
     * Get a list of event attendee statuses
     * @returns db_DropdownEventAttendeeStatus OK
     * @throws ApiError
     */
    public static listEventAttendeeStatuses(): CancelablePromise<Array<db_DropdownEventAttendeeStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/event-attendee-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
